import React, { useState } from "react";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
  Box,
  Stack,
  Button,
  DialogActions,
} from "@mui/material";
import { connect } from "react-redux";
import { GetAllUsers } from "../../../../Redux/Actions/actions";
import {
  AudioMsg,
  DocMsg,
  ImageMsg,
  TextMsg,
  Timeline,
  VideoMsg,
} from "../../Chat-component/MessageTypes-component/PreviewMsgType";
import EmailBody from "../../Chat-component/EmailBodyComponent/EmailBody";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const MessageSummeryComponent = (props) => {
  const {
    OpenDialog,
    handleClose,
    summerydata,
    ChatHistory,
    Sessionvalforemail,
  } = props;

  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        Interaction Summary
      </DialogTitle>
      <DialogContent className="pb-0">
        <DialogContentText
          id="alert-dialog-slide-description"
          className="mt-3"
          sx={{ display: "flex", justifyContent: "center", gap: 2 }}
        >
          {(() => {
            switch (summerydata[0].channel) {
              case "webchat":
              case "from_whatsapp":
              case "from_facebook":
              case "from_purple":
              case "from_google":
                return (
                  <Box
                    className="p-2 box-inset2 "
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#edf4fd",
                      borderRadius: 0,
                      overflowY: "scroll",
                      scrollBehavior: "smooth",
                    }}
                    p={1}
                  >
                    <Stack spacing={2}>
                      {ChatHistory.length > 0
                        ? ChatHistory.map((el, index) => {
                          switch (el.msg_sent_type) {
                            case "NOTIFICATIONS":
                              return <Timeline el={el} key={index} />;
                            case "jpeg":
                            case "png":
                            case "IMAGE":
                              return (
                                <ImageMsg el={el} menu={false} key={index} />
                              );
                            case "vnd.openxmlformats-officedocument.wordprocessingml.document":
                              return (
                                <DocMsg
                                  el={el}
                                  menu={false}
                                  key={index}
                                  type={"docx"}
                                  size={"100px"}
                                />
                              );
                            case "pdf":
                              return (
                                <DocMsg
                                  el={el}
                                  menu={false}
                                  key={index}
                                  type={"pdf"}
                                  size={"100px"}
                                />
                              );
                            case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                              return (
                                <DocMsg
                                  el={el}
                                  menu={false}
                                  key={index}
                                  type={"xlsx"}
                                  size={"100px"}
                                />
                              );
                            case "plain":
                              return (
                                <DocMsg
                                  el={el}
                                  menu={false}
                                  key={index}
                                  type={"plain"}
                                  size={"100px"}
                                />
                              );

                              case "msword":
                                return (
                                  <DocMsg
                                    el={el}
                                    menu={false}
                                    key={index}
                                    type={"plain"}
                                    size={"100px"}
                                  />
                                );
                            case "AUDIO":
                              return (
                                <AudioMsg el={el} menu={false} key={index} />
                              );
                              case "wav":
                                return (
                                  <AudioMsg el={el} menu={false} key={index} />
                                );
                            case "mp4":  
                              return (
                              <VideoMsg el={el} menu={false} key={index} />
                            );
                            case "VIDEO":
                              return (
                                <VideoMsg el={el} menu={false} key={index} />
                              );
                              case "webm":
                                return (
                                  <VideoMsg el={el} menu={false} key={index} />
                                );
                            default:
                              return (
                                <TextMsg
                                  el={el}
                                  menu={false}
                                  key={index}
                                  size={"220px"}
                                />
                              );
                          }
                        })
                        : null}
                    </Stack>
                  </Box>
                );
              case "email":
                return (
                  <Box
                    className="p-2 box-inset2 "
                    sx={{
                      flexGrow: 1,
                      backgroundColor: "#edf4fd",
                      borderRadius: 0,
                      overflowY: "scroll",
                      scrollBehavior: "smooth",
                    }}
                    p={1}
                  >
                    <Stack spacing={2}>
                      {Sessionvalforemail.length > 0
                        ? Sessionvalforemail.map((mail, index) => {
                            return (
                              <EmailBody
                                mail={mail}
                                index={index}
                                handleChange={handleChange}
                                expanded={expanded}
                                preview={true}
                                action={false}
                              />
                            );
                          })
                        : null}
                    </Stack>
                  </Box>
                );
              default:
                return <></>;
            }
          })()}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  GetAllUsers,
})(MessageSummeryComponent);
